module.exports = __webpack_public_path__ + "static/assets/db66b6660b88774576071c152c644ff8.png";